import React from "react";
import { Chip } from "@mui/material";

const WellBeingMovement = ({ user }) => {
  const status = user?.is_moving;

  const getColor = () => {
    return status ? { color: "#0d47a1", text: "In Motion" } : { color: "#d50000", text: "Stopped" };
  };

  const color = getColor();

  return (
    <Chip
      label={<div style={{ textAlign: "center" }}>{color.text}</div>}
      style={{
        backgroundColor: color.color,
        color: "white",
        borderRadius: "5px",
        fontWeight: "bold",
        height: "auto",
        padding: "5px",
      }}
    />
  );
};

export default React.memo(WellBeingMovement);
